module.exports = __webpack_public_path__ + "img/selected1-min.6855aa2b.png";